import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getJobList } from "../../redux/actions/JobActions";
import {
  createCandidate,
  getCandidateList,
  updateCandidate,
  candidateLogout,
  AddProfileImage,
} from "../../redux/actions/admin/CandidateActions";
import { CircularProgress } from "@material-ui/core";
import { categories } from "../shared/Helper";
import CustomAlert from "../shared/views/CustomAlert";
import moment from "moment";
import "moment/locale/fr";
import localStorageService from "../../services/localStorageService";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import Select from "react-select";
import isMatch from "date-fns/isMatch";
import validator from "validator";
import siteService from "../../services/siteService";
import authentificationService from "../../services/authentificationService";
import { useHistory, useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) =>
  createStyles({
    previewChip: {
      minWidth: 160,
      maxWidth: 210,
    },
  })
);

let CandidateProfile = (props) => {
  const { updateCandidate, AddProfileImage } = props;
  const currentSite = siteService.getCurrentSite();
  const [isLoading, setIsLoading] = React.useState(true);
  const [hasMissingValue, setHasMissingValue] = React.useState(true);
  const [isUpdating, setIsUpdating] = React.useState(false);
  const [updated, setUpdated] = React.useState(false);

  const [candidatToUpdate, setCandidatToUpdate] = React.useState({
    firstName: "",
    lastName: "",
    phoneNumber1: "",
    phoneNumber2: "",
    address: "",
    email: "",
    password: "",
    confirmPassword: "",
    attachments: [
      {
        id: "",
        externalRepositoryId: "",
        fullName: "",
        name: "",
        dateCreated: "",
        dateModified: "",
        modificationDate: null,
        fileInfo: null,
        url: "",
        metadata: {},
        parent: null,
      },
    ],
  });
  const [invalideEmail, setInvalideEmail] = React.useState(false);
  const [invalideDate, setInvalideDate] = React.useState(false);
  const [avatarImage, setAvatarImage] = React.useState(null);
  const fileInputRef = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const [currrentPathName, setCurrrentPathName] = React.useState("");

  useEffect(() => {
    getPathName();
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    if (candidate) {
      setCandidatToUpdate(candidate);
    } else {
      history.push(`/`);
    }
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    setCurrrentPathName(location.pathname);
  }, [location]);

  useEffect(() => {
    if (
      candidatToUpdate !== undefined &&
      candidatToUpdate.id !== undefined &&
      candidatToUpdate.id != "" &&
      isLoading == true
    ) {
      setIsLoading(false);
    }
    if (
      candidatToUpdate?.firstName == "" ||
      candidatToUpdate?.firstName === undefined ||
      candidatToUpdate?.lastName == "" ||
      candidatToUpdate?.lastName === undefined ||
      candidatToUpdate?.email == "" ||
      candidatToUpdate?.email === undefined
    ) {
      setHasMissingValue(true);
    } else if (
      candidatToUpdate?.firstName?.length > 50 ||
      candidatToUpdate?.lastName?.length > 50 ||
      candidatToUpdate?.birthPlace?.length > 50 ||
      candidatToUpdate?.phoneNumber1?.length > 50 ||
      candidatToUpdate?.phoneNumber2?.length > 50 ||
      candidatToUpdate?.email?.length > 50 ||
      // || !isMatch(candidatToUpdate?.birthDay, 'yyyy-MM-dd')
      (candidatToUpdate?.phoneNumber1 != "" &&
        !new RegExp(/^[0-9\b]+$/).test(candidatToUpdate?.phoneNumber1)) ||
      (candidatToUpdate?.phoneNumber2 != "" &&
        !new RegExp(/^[0-9\b]+$/).test(candidatToUpdate?.phoneNumber2)) ||
      (candidatToUpdate?.email != "" &&
        !validator.isEmail(candidatToUpdate?.email))
    ) {
      setHasMissingValue(true);
    } else {
      setHasMissingValue(false);
    }
  }, [candidatToUpdate]);

  const handleSubmit = () => {
    setIsUpdating(true);
    let candidat = candidatToUpdate;
    if (candidat.birthDay == "") {
      candidat.birthDay = null;
    }
    updateCandidate(candidat).then((data) => {
      if (data.success) {
        setUpdated(true);
        setCandidatToUpdate(data.candidate);
      }
      setIsUpdating(false);
    });
  };

  // Start keydown mechanism
  let onKeydown = (event) => {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      if (!hasMissingValue) {
        handleSubmit();
      }
      event.preventDefault();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", onKeydown);
    return () => {
      document.removeEventListener("keydown", onKeydown);
    };
  }, [onKeydown]);
  //End keydown mechanism

  let disconnect = (sessionType) => {
    authentificationService.logout(sessionType);
    if (sessionType == "candidate") {
      candidateLogout();
      window.location = "/";
    }
  };

  const handleImageChange = (event) => {
    event.preventDefault();
    if (event.target.files.length > 0) {
      try {
        let candidate = localStorageService.getItem("malibaara_auth_candidate");
        AddProfileImage(candidate?.id, event.target.files).then((res) => {
          if (res.success) {
            setCandidatToUpdate(res.candidate);
          }
        });
      } catch (error) {
        console.error("Error uploading profile image:", error);
      }
    }
  };

  let getPathName = () => {
    let pathName = window.location.pathname;
    setCurrrentPathName(pathName);
  };
  // const isActiveLink = (path) => {
  //   return window.location.pathname === path;
  // };

  return (
    <React.Fragment>
      {isLoading ? (
        <div className="loading-container">
          <CircularProgress />
          <div>Chargement du formulaire en cours...</div>
        </div>
      ) : (
        <>
          <div className="col-lg-8">
            <div className="row">
              {/* Informations de base */}
              <div className="col-xl-12">
                <div className="bg-light-3 p-4">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="section-title">
                        <h2 className="title">
                          <span>Mes informations</span>
                        </h2>
                        {/* <p></p> */}
                      </div>
                    </div>
                  </div>
                  <div _lpchecked="1">
                    <div className="form-row">
                      <div className="form-row">
                        <div className="form-group col-md-6">
                          <label>Prénom *</label>
                          <input
                            value={candidatToUpdate?.firstName}
                            type="text"
                            className="form-control"
                            id="firstName"
                            placeholder=""
                            onChange={(e) => {
                              let val = e.target?.value;
                              setCandidatToUpdate((prevState) => {
                                return { ...prevState, firstName: val };
                              });
                            }}
                          />
                          {candidatToUpdate?.firstName?.length > 50 && (
                            <p style={{ color: "red" }}>
                              le nombre maximum de caractères a été dépassé
                            </p>
                          )}
                        </div>
                        <div className="form-group col-md-6">
                          <label>Nom *</label>
                          <input
                            type="text"
                            value={candidatToUpdate?.lastName}
                            className="form-control"
                            id="lastName"
                            placeholder=""
                            onChange={(e) => {
                              let val = e.target?.value;
                              setCandidatToUpdate((prevState) => {
                                return { ...prevState, lastName: val };
                              });
                            }}
                          />
                          {candidatToUpdate?.lastName?.length > 50 && (
                            <p style={{ color: "red" }}>
                              le nombre maximum de caractères a été dépassé
                            </p>
                          )}
                        </div>
                        <div className="form-group col-md-6">
                          <label>Date de naissance</label>
                          <input
                            value={moment(candidatToUpdate?.birthDay)?.format(
                              "YYYY-MM-DD"
                            )}
                            type="date"
                            className="form-control"
                            id="birthDay"
                            placeholder=""
                            onChange={(e) => {
                              let val = e.target?.value;
                              let match = isMatch(e.target.value, "yyyy-MM-dd");
                              setCandidatToUpdate((prevState) => {
                                return { ...prevState, birthDay: val };
                              });
                              if (match && val != "") {
                                setInvalideDate(!match);
                              }
                            }}
                            onBlur={(e) => {
                              let val = isMatch(e.target.value, "yyyy-MM-dd");
                              if (e.target.value != "") {
                                setInvalideDate(!val);
                              }
                              if (!val) {
                                setCandidatToUpdate((prevState) => {
                                  return { ...prevState, birthDay: "" };
                                });
                              }
                            }}
                          />
                          {invalideDate && (
                            <p style={{ color: "red" }}>Format invalide</p>
                          )}
                        </div>
                        <div className="form-group col-md-6">
                          <label>Lieu de naissance</label>
                          <input
                            type="text"
                            value={candidatToUpdate?.birthPlace}
                            className="form-control"
                            id="birthPlace"
                            placeholder=""
                            onChange={(e) => {
                              let val = e.target?.value;
                              setCandidatToUpdate((prevState) => {
                                return { ...prevState, birthPlace: val };
                              });
                            }}
                          />
                          {candidatToUpdate?.birthPlace?.length > 50 && (
                            <p style={{ color: "red" }}>
                              le nombre maximum de caractères a été dépassé
                            </p>
                          )}
                        </div>
                        <div className="form-group col-md-6">
                          <label>
                            Numero de téléphone (
                            {siteService.getCurrentSite().operatorName1})
                          </label>
                          <input
                            type="text"
                            value={candidatToUpdate?.phoneNumber1}
                            className="form-control"
                            id="phoneNumber1"
                            placeholder=""
                            onChange={(e) => {
                              let val = e.target?.value;
                              setCandidatToUpdate((prevState) => {
                                return {
                                  ...prevState,
                                  phoneNumber1: val,
                                };
                              });
                            }}
                          />
                          {candidatToUpdate?.phoneNumber1?.length > 50 && (
                            <p style={{ color: "red" }}>
                              le nombre maximum de caractères a été dépassé
                            </p>
                          )}
                          {candidatToUpdate?.phoneNumber1 != "" &&
                            !new RegExp(/^[0-9\b]+$/).test(
                              candidatToUpdate?.phoneNumber1
                            ) && (
                              <p style={{ color: "red" }}>Format invalide</p>
                            )}
                        </div>
                        <div className="form-group col-md-6">
                          <label>
                            Numero de téléphone (
                            {siteService.getCurrentSite().operatorName2})
                          </label>
                          <input
                            type="text"
                            value={candidatToUpdate?.phoneNumber2}
                            className="form-control"
                            id="phoneNumber2"
                            placeholder=""
                            onChange={(e) => {
                              let val = e.target?.value;
                              setCandidatToUpdate((prevState) => {
                                return {
                                  ...prevState,
                                  phoneNumber2: val,
                                };
                              });
                            }}
                          />
                          {candidatToUpdate?.phoneNumber2?.length > 50 && (
                            <p style={{ color: "red" }}>
                              le nombre maximum de caractères a été dépassé
                            </p>
                          )}
                          {candidatToUpdate?.phoneNumber2 != "" &&
                            !new RegExp(/^[0-9\b]+$/).test(
                              candidatToUpdate?.phoneNumber2
                            ) && (
                              <p style={{ color: "red" }}>Format invalide</p>
                            )}
                        </div>
                        <div className="form-group col-md-12">
                          <label>Adresse (Rue, Quartier, Ville, Pays)</label>
                          <input
                            value={candidatToUpdate?.address}
                            type="text"
                            className="form-control"
                            id="address"
                            placeholder=""
                            onChange={(e) => {       
                              let val = e.target?.value;
                              let isValide = validator.isEmail(e.target.value);
                              setCandidatToUpdate((prevState) => {
                                return { ...prevState, address: val };
                              });
                            }}
                          />
                        </div>
                        <div className="form-group col-md-12">
                          <label>Email *</label>
                          <input
                            value={candidatToUpdate?.email}
                            type="text"
                            className="form-control"
                            id="email"
                            placeholder=""
                            onChange={(e) => {
                              let val = e.target?.value;
                              let isValide = validator.isEmail(e.target.value);
                              setCandidatToUpdate((prevState) => {
                                return { ...prevState, email: val };
                              });
                              if (invalideEmail) {
                                setInvalideEmail(!isValide);
                              }
                            }}
                            onBlur={(e) => {
                              let val = validator.isEmail(e.target.value);
                              setInvalideEmail(!val);
                            }}
                          />
                          {candidatToUpdate?.email?.length > 50 && (
                            <p style={{ color: "red" }}>
                              le nombre maximum de caractères a été dépassé
                            </p>
                          )}
                          {candidatToUpdate?.email != "" && invalideEmail && (
                            <p style={{ color: "red" }}>
                              Format d'email invalide
                            </p>
                          )}
                        </div>
                        <div className="form-group col-md-12">
                          <label>Catégorie</label>
                          <Select
                            value={categories.filter((opt) =>
                              candidatToUpdate?.categories?.some(
                                (cat) => cat == opt.value
                              )
                            )}
                            options={categories}
                            loadingMessage="En cours de chargement"
                            isMulti
                            onChange={(option) => {
                              const unique = [
                                ...new Set(option.map((item) => item.value)),
                              ];
                              setCandidatToUpdate((prevState) => {
                                return {
                                  ...prevState,
                                  categories: unique,
                                };
                              });
                            }}
                          />
                        </div>
                        <div className="form-group col-md-12">
                          <div className="custom-control custom-checkbox">
                            <input
                              checked={
                                candidatToUpdate?.receiveEmailNotification
                              }
                              type="checkbox"
                              className="custom-control-input"
                              id="accepts-01"
                              onChange={(e) => {
                                let val = e.target?.checked;
                                setCandidatToUpdate((prevState) => {
                                  return {
                                    ...prevState,
                                    receiveEmailNotification: val,
                                  };
                                });
                              }}
                            />
                            <label
                              className="custom-control-label"
                              for="accepts-01"
                            >
                              Recevoir les offres d'empoi par email
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox">
                            <input
                              checked={candidatToUpdate?.receiveSmsNotification}
                              type="checkbox"
                              className="custom-control-input"
                              id="accepts-02"
                              onChange={(e) => {
                                let val = e.target?.checked;
                                setCandidatToUpdate((prevState) => {
                                  return {
                                    ...prevState,
                                    receiveSmsNotification: val,
                                  };
                                });
                              }}
                            />
                            <label
                              className="custom-control-label"
                              for="accepts-02"
                            >
                              Recevoir les offres d'emploi par SMS
                            </label>
                          </div>
                        </div>
                        <div className="col-12 mt-4">
                          <button
                            className="btn btn-primary"
                            onClick={handleSubmit}
                            disabled={isUpdating || hasMissingValue}
                          >
                            Soumettre &nbsp;{" "}
                            {isUpdating ? (
                              <CircularProgress size={15} />
                            ) : (
                              <span></span>
                            )}
                          </button>
                        </div>
                        {updated && (
                          <div className="col-12 mt-4">
                            <CustomAlert
                              content={
                                "<strong>Félicitations!</strong> Ce compte candidat a été modifié avec succès. "
                              }
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

CandidateProfile.propTypes = {
  getJobList: PropTypes.func.isRequired,
  createCandidate: PropTypes.func.isRequired,
  candidateLogout: PropTypes.func.isRequired,
  AddProfileImage: PropTypes.func.isRequired,
  getCandidateList: PropTypes.func.isRequired,
  storeJob: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  getJobList: PropTypes.func.isRequired,
  getCandidateList: PropTypes.func.isRequired,
  createCandidate: PropTypes.func.isRequired,
  updateCandidate: PropTypes.func.isRequired,
  candidateLogout: PropTypes.func.isRequired,
  AddProfileImage: PropTypes.func.isRequired,
  storeJob: state.job,
  storeEmployer: state.employer,
});

export default connect(mapStateToProps, {
  getJobList,
  createCandidate,
  getCandidateList,
  updateCandidate,
  candidateLogout,
  AddProfileImage,
})(CandidateProfile);
